// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__JA08i","left":"StickyBox_left__3vUs3","right":"StickyBox_right__1LLgW"};